import { FourStageRoutingDiagram } from '../components/FourStageRoutingDiagram';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './HowKAIWorksSection.module.css';

const promises = [
  'No identifying student data ever reaches a model provider.',
  'No training on student or faculty queries. Contractually enforced.',
  "Models can be swapped without changing the institution's contract.",
] as const;

export function HowKAIWorksSection() {
  return (
    <SectionWrapper
      background="navy"
      contentClassName={styles.content}
      data-testid="ai-section-how-kai-works"
      id="how-kai-works"
    >
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>HOW KAI WORKS</p>
          <h2 className={styles.title}>
            How a query travels - and what we promise about it.
          </h2>
          <p className={styles.subhead}>
            Every KAI interaction follows the same path. The architecture is
            what makes the privacy and pedagogy commitments credible.
          </p>
        </div>

        <FourStageRoutingDiagram />

        <div className={styles.promises}>
          {promises.map((promise, index) => (
            <article className={styles.promise} key={promise}>
              <span className={styles.promiseLabel}>
                PROMISE {String(index + 1).padStart(2, '0')}
              </span>
              <p className={styles.promiseText}>{promise}</p>
            </article>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
